import React from "react";
import Jumbotron from "../components/Jumbotron";
import ArticleItem from "../components/ArticleItem";
import Link, { navigateTo } from "gatsby-link";
import SubNav from "../components/sub-nav";
import SectionTitle from "../components/SectionTitle";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";

const renderPubs = (pubs = []) => {
	return pubs.map(({ node }, i) => {
		return (
			<div
				key={"pub-" + (i + 1)}
				className="col-12 col-sm-6 article_list_item"
			>
				<ArticleItem
					category={"Publication"}
					cat_url="/publications"
					title={node.publicationTitle.publicationTitle}
					url={node.url}
					excerpt={node.authors.join(", ")}
					pub_details={node.journal}
					published_date={node.publicationDate}
				/>
			</div>
		);
	});
};

class Publications extends React.Component {
	handleSelect = year => {
		const locale = this.props.data.contentfulPublicationsPage.node_locale;
		navigateTo({
			pathname: `/${locale}/publications/${year}`
		});
	};

	render() {
		const { transition, pathContext, data } = this.props;

		const { allYears, year } = pathContext;
		const pageSettings = data.contentfulPublicationsPage;
		const publicationsList = data.allContentfulPublicationLink.edges;

		const processedYears = allYears.map(item => {
			return {
				label: item,
				name: item,
				href: `/${pageSettings.node_locale}/publications/${item}`
			};
		});

		return (
			<PageWrapper
				locale={pageSettings.node_locale}
				location={this.props.location}
				data={data.layout.edges[0].node}
			>
				<main role="main" style={transition && transition.style}>
				<Helmet title={pageSettings.pageTitle + " | " + year + " | Mahidol Vivax Research Unit"} />
					<Jumbotron
						type="jumbotron_b"
						bottomLine={false}
						className="mb-0"
						textAlign="text-center"
						contentAlign="justify-content-md-center"
					>
						<h1>{pageSettings.pageTitle}</h1>
					</Jumbotron>

					<div className="container d-none d-xl-block">
						<div className="row justify-content-center">
							<div className="col-lg-12">
								<SubNav
									navList={processedYears}
									active={year}
									handleClick={() => {}}
								/>
							</div>
						</div>
					</div>

					<div className="container mt-3 mt-lg-0">
						<SectionTitle type="b" title={year} />
						<div className="row justify-content-center">
							<div className="col-12 col-sm-6 col-md-4 d-xl-none">
								<div className="form-group">
									<select
										className="form-control text-center select-style"
										id="exampleFormControlSelect1"
										placeholder="Readonly input here…"
										onChange={e =>
											this.handleSelect(e.target.value)
										}
									>
										<option
											className="text-center"
											value=""
											disabled
											selected
											hidden
										>
											Choose different year...
										</option>
										{allYears.map(item => (
											<option
												disabled={item === year}
												selected={false}
												key={item}
											>
												{item}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
					</div>

					<div className="container py-5">
						<div className="row justify-content-start mb-5">
							{publicationsList.length > 0 ? (
								renderPubs(publicationsList)
							) : (
								<div className="col-12 text-center my-5	">
									<h4>
										Oops! Couldn't find any publications
										from this year
									</h4>
								</div>
							)}
						</div>

						<div className="row">
							<div className="col-6 text-left">
								{allYears.indexOf(year) > 0 &&
									<Link className={"h5"} to={`/${pageSettings.node_locale}/publications/${allYears[allYears.indexOf(year) - 1]}`}>
										&laquo; {allYears[allYears.indexOf(year) - 1]}
									</Link>
									
									}
							</div>
							<div className="col-6 text-right">
								{allYears.indexOf(year) < (allYears.length - 1) &&
									<Link className={"h5"} to={`/${pageSettings.node_locale}/publications/${allYears[allYears.indexOf(year) + 1]}`}>
										{allYears[allYears.indexOf(year) + 1]} &raquo;
									</Link>}
							</div>
						</div>
					</div>
				</main>
			</PageWrapper>
		);
	}
}

export default Publications;
export const query = graphql`
	query PublicationsPerYearQuery(
		$id: String!
		$locale: String!
		$yearRegX: String!
	) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		allContentfulPublicationLink(
			filter: {
				node_locale: { eq: $locale }
				publicationDate: { regex: $yearRegX }
			}
			sort: { order: DESC, fields: [publicationDate] }
		) {
			edges {
				node {
					node_locale
					publicationTitle {
						publicationTitle
					}
					url
					authors
					journal
					publicationDate(formatString: "YYYY MMM DD")
					year: publicationDate(formatString: "YYYY")
				}
			}
		}

		contentfulPublicationsPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/publications-template.js